import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/contexts/auth";
import { useOrganizationResourcesClient } from "@/features/credentials/hooks/use-organization-resources-client";
import { getListItems } from "@/features/credentials/lib/get-list-items";
import { uniqueBy } from "@/features/credentials/lib/unique-by";
import { organizationResourcesQueryKeys } from "@/features/credentials/queries/organization-resources-query-keys";

export function useVenuesListQuery({
  sport,
  organizationId,
  enabled,
}: {
  sport: string;
  organizationId: string;
  enabled: boolean;
}) {
  const { productToken } = useAuth();
  const organizationResourcesClient = useOrganizationResourcesClient();

  return useQuery({
    queryKey: organizationResourcesQueryKeys.venues({ sport, organizationId }),
    queryFn: () =>
      organizationResourcesClient.getVenues({
        productToken: productToken as string,
        sport,
        organizationId,
      }),
    enabled: enabled && !!productToken && !!sport && !!organizationId,
    select: (response) => uniqueBy(getListItems(response), (venue) => String(venue.venueId ?? "")),
  });
}
